import React, { useState, useEffect } from "react"
import { DragDropContext, Droppable, Draggable, resetServerContext } from "react-beautiful-dnd"
import {
    Checkbox,
    Layout,
    ChoiceList,
    Stack,
    TextStyle,
    Card,
    Popover,
    Button,
} from "@shopify/polaris"

const ListAttribute = (props) => {
    resetServerContext()
    const { attribute_compare, compare_options } = props
    const [listOptions, setListOptions] = useState([])
    useEffect(() => {
        setListOptions(compare_options)
    }, [props])

    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = [...list]
        const [removed] = result.splice(startIndex, 1)
        result.splice(endIndex, 0, removed)
        return result
    }

    const onDragEnd = (result) => {
        console.log("result :>> ", result)
        // dropped outside the list
        if (!result.destination) {
            return
        }
        const compare_temp = [...listOptions]
        const collection = result.destination.droppableId
        const findIndex = compare_temp.findIndex((item) => item.key === collection)
        if (findIndex === -1) {
            return
        }
        const items = reorder(
            compare_temp[findIndex].data,
            result.source.index,
            result.destination.index,
        )
        compare_temp[findIndex] = {
            ...compare_temp[findIndex],
            data: [...items],
        }
        setListOptions(compare_temp)
        props.changeCompareOptions(compare_temp)
    }

    const changeOptionsStatus = (data) => {
        const compare_temp = [...listOptions]
        const findCollection = compare_temp.findIndex((item) => item.key === data.collection)
        if (findCollection === -1) {
            const obj = {
                key: data.collection,
                data: [...data.val],
            }
            compare_temp.push(obj)
        } else {
            compare_temp[findCollection] = {
                ...compare_temp[findCollection],
                data: [...data.val],
            }
        }
        props.changeCompareOptions(compare_temp)
    }

    const [popoverActive, setPopoverActive] = useState(null)

    const togglePopoverActive = (id) => {
        popoverActive === id ? setPopoverActive(-1) : setPopoverActive(id)
    }

    return (
        <div>
            <div style={{ marginBottom: "15px" }}>
                <TextStyle variation="subdued">
                    To use this feature you need to use the{" "}
                    <a
                        href="https://apps.shopify.com/advanced-custom-field#modal-show=AuthModal"
                        target="_blank"
                        rel="noopener"
                    >
                        ACF app
                    </a>{" "}
                    to customize the compare property
                </TextStyle>
            </div>
            <div style={{ marginBottom: "15px" }}>
                <TextStyle>
                    <a
                        href="https://support.arenacommerce.com/support/tickets/new"
                        target="_blank"
                        rel="noopener"
                    >
                        How to work
                    </a>
                </TextStyle>
            </div>
            <Stack spacing="extraLoose">
                <Stack.Item>
                    <h2 style={{ fontWeight: "600", paddingBottom: "10px" }}>List Attribute</h2>
                    <Card>
                        {attribute_compare.map((item, index) => {
                            const collection = item.key
                            const findIndex = listOptions.findIndex((idx) => idx.key === collection)
                            let selected = []
                            if (findIndex === -1) {
                                selected = []
                            } else {
                                selected = [...listOptions[findIndex].data]
                            }
                            return (
                                <Card.Section key={index}>
                                    <Stack alignment="center" distribution="equalSpacing">
                                        <TextStyle>{item.key}</TextStyle>
                                        <Popover
                                            active={popoverActive == index ? true : false}
                                            activator={
                                                <Button
                                                    onClick={() => togglePopoverActive(index)}
                                                    disclosure
                                                >
                                                    attributes
                                                </Button>
                                            }
                                            onClose={togglePopoverActive}
                                        >
                                            <Card sectioned>
                                                <ChoiceList
                                                    allowMultiple
                                                    choices={item.data.map((x) => ({
                                                        label: x,
                                                        value: x,
                                                    }))}
                                                    selected={selected}
                                                    onChange={(val, name) =>
                                                        changeOptionsStatus({
                                                            collection: collection,
                                                            val,
                                                            name,
                                                        })
                                                    }
                                                />
                                            </Card>
                                        </Popover>
                                    </Stack>
                                </Card.Section>
                            )
                        })}
                    </Card>
                </Stack.Item>
                <Stack.Item>
                    <h2 style={{ fontWeight: "600", paddingBottom: "10px" }}>List Choices</h2>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        {listOptions.map(
                            (compare, idx) =>
                                compare.data.length !== 0 && (
                                    <div style={{ marginTop: "15px" }} key={idx}>
                                        <h1 style={{ fontWeight: "600" }}>{compare.key}</h1>
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <Droppable
                                                droppableId={`${compare.key}`}
                                                type={`${compare.key}`}
                                            >
                                                {(provided) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {compare.data.map((item, index) => (
                                                            <Draggable
                                                                key={index}
                                                                draggableId={`${compare.key}-${index}`}
                                                                index={index}
                                                                type={`${compare.key}`}
                                                            >
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                padding: "5px",
                                                                            }}
                                                                        >
                                                                            {item}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                ),
                        )}
                    </div>
                </Stack.Item>
            </Stack>
        </div>
    )
}

export default ListAttribute
